import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DescuentosPerdidasModalComponent } from '../modales/descuentos/descuentos-perdidas-modal/descuentos-perdidas-modal.component';
import { DescuentosExcesosModalComponent } from '../modales/descuentos/descuentos-excesos-modal/descuentos-excesos-modal.component';
import { DescuentosLiquidasModalComponent } from '../modales/descuentos/descuentos-liquidas-modal/descuentos-liquidas-modal.component';
import { DescuentosPagosICAModalComponent } from '../modales/descuentos/descuentos-pagos-ica-modal/descuentos-pagos-ica-modal.component';
import { DescuentosDonacionesModalComponent } from '../modales/descuentos/descuentos-donaciones-moda/descuentos-donaciones-modal.component';
import { DescuentosAFProductivosModalComponent } from '../modales/descuentos/descuentos-af-productivos-modal/descuentos-af-productivos-modal.component';
import { DescuentosRentaAnteriorModalComponent } from '../modales/descuentos/descuentos-renta-anterior-modal/descuentos-renta-anterior-modal.component';
import { DescuentosRetencionModalComponent } from '../modales/descuentos/descuentos-retencion-modal/descuentos-retencion-modal.component';
import { DescuentosSancionModalComponent } from '../modales/descuentos/descuentos-sancion-modal/descuentos-sancion-modal.component';
import { DescuentosSancionExtemporaneaModalComponent } from '../modales/descuentos/descuentos-sancion-extemporanea-modal/descuentos-sancion-extemporanea-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { DescuentosRentaPresuntivaModalComponent } from '../modales/descuentos/descuentos-renta-presuntiva-modal/descuentos-renta-presuntiva-modal.component';
import { DescuentosSaldoAFavorModalComponent } from '../modales/descuentos/descuentos-saldo-a-favor/descuentos-saldo-a-favor-modal';
import { DialogoConfirmacionComponent } from '../../../table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { BeneficiosTributariosDeduccionesEspecialesModalComponent } from '../modales/beneficios-tributarios/beneficios-tributarios-deducciones-especiales/beneficios-tributarios-deducciones-especiales-modal.component';
import { BeneficiosDependientesModalComponent } from '../modales/beneficios-tributarios/beneficios-dependientes-modal/beneficios-dependientes-modal.component';
import { BeneficiosComprasFacturaElectronicaModalComponent } from '../modales/beneficios-tributarios/beneficios-compras-factura-electronica/beneficios-compras-factura-electronica-modal.component';
import { BeneficiosIngresosNoGravados } from '../modales/beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { BeneficiosTributariosDescuentosModalComponent } from '../modales/beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { BeneficiosRentasExentasSinLimiteModalComponent } from '../modales/beneficios-tributarios/beneficios-rentas-exentas-sin-limite-modal/beneficios-rentas-exentas-sin-limite-modal.component';
import { BeneficiosRentasExentasDeImpuestoModalComponent } from '../modales/beneficios-tributarios/beneficios-rentas-exentas-de-impuesto/beneficios-rentas-exentas-de-impuesto-modal.component';
import { ComponentFactoryService } from '../../../../services/component-factory.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../modales/ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../modales/ingresos/ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';


const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions: Question[] = [
  {
    question: '¿Hizo compras con factura electrónica?',
    field: 'cs_id_652', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_656"
  },
  {
    question: '¿Tuvo dependientes económicos?',
    field: 'cs_id_668', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_673"
  },
  {
    question: '¿Tuvo ingresos no gravados con renta como aportes obligatorios a pensión y a salud, entre otros?',
    field: 'cs_id_373', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_686"
  },
  {
    question: '¿Tuvo rentas exentas del impuesto, que no tiene las limitantes de ley?',
    field: 'cs_id_757', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_763"
  },
  {
    question: '¿Tuvo rentas exentas de impuesto, como aportes voluntarios a pensión, cuentas AFC o cesantías?',
    field: 'cs_id_705', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_700"
  },
  {
    question: '¿Tuvo deducciones especiales como pagos a medicina prepagada, aportes a cesantías o 4x1.000 (GMF)?',
    field: 'cs_id_708', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_714"
  },
  {
    question: '¿Tuvo descuentos tributarios?',
    field: 'cs_id_725', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_728"
  }
];

@Component({
  selector: 'app-mis-beneficios-tributarios',
  templateUrl: './mis-beneficios-tributarios.component.html',
  styleUrls: ['./mis-beneficios-tributarios.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class MisBeneficiosTributariosComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Input('listaTipoRenta') listaTipoRenta: DValorDominio[] = [];
  @Input('listaConcDeduEspe') listaConcDeduEspe: DValorDominio[] = [];
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  @Input('tablaArt73') tablaArt73: any;
  @Input('valorUVT') valorUVT: any;
  @Input('tiposDocumento') tiposDocumento: any;
  @Input('tiposParentesco') tiposParentesco: any;
  @Input('uvt') uvt: string;
  @Input('listConcDescTrib') listConcDescTrib: any;
  @Input('listaConcpRentaExenSinLimite') listaConcpRentaExenSinLimite: any;
  @Input('listaTipRentaAFC') listaTipoRentaExenSinLimite: any;
  @Input('parametroPoliticaAFC') parametroPoliticaAFC: any;
  @Input('conceptosRentasExentas') conceptosRentasExentas: any;
  @Input('listaConceptosIngreNoGravados') listaConceptosIngreNoGravados: any;

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService,
    private _componentFactory: ComponentFactoryService,


  ) {
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.initializeSiTieneSugerida();
  }

  validateQuestions(id: number) {
    console.log(id);
  }

  questionHasSugerida(index: number) {
    return questions[index].hasSuggested == "1";
  }
  /**
   * Inicializa las respuestas en Sí si la sección tiene sugerida
   */
  initializeSiTieneSugerida() {
    for (let numPregunta = 0; numPregunta < questions.length; numPregunta++) {
      if (this.questionHasSugerida(numPregunta) && questions[numPregunta].resp != "0") {
        questions[numPregunta].resp = '1';
        this.model.doc.cuerpo[questions[numPregunta].field] = "1";
      }
    }
  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'model2100Completed') {

      }
    });
  }

  initilizeQuestionsDesdeModelo(model) {
    for (let i = 0; i < questions.length; i++) {
      questions[i].resp = model.doc.cuerpo[questions[i].field];
      questions[i].isCompleted = this.validateModalCompleted(i);
      if (questions[i].isCompleted || model.doc.cuerpo[questions[i].field] == "1") { questions[i].show = true; }
      this.checkNextQuestion(i);
    }
  }

  openModal(indexQuestionModal: number) {
    const configSinSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    const configSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: {
        model: this.model
      }
    }
    let config;
    if (this.questionHasSugerida(indexQuestionModal)) {
      config = configSugerida;
    } else {
      config = configSinSugerida;
    }

    switch (indexQuestionModal) {
      case 0:
        let dialog0: MatDialogRef<BeneficiosComprasFacturaElectronicaModalComponent> = this.dialog.open(BeneficiosComprasFacturaElectronicaModalComponent, config);
        dialog0.componentInstance.valorUVT = this.uvt;
        dialog0.componentInstance.tiposDocumento = this.tiposDocumento;
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:  // 668	B2	¿Tuvo dependientes económicos?	NO	Ayuda Pregunta 2, se actualizará una vez esté revisada por el área funcional.
        let dialog1: MatDialogRef<BeneficiosDependientesModalComponent> = this.dialog.open(BeneficiosDependientesModalComponent, config);
        dialog1.componentInstance.tiposDocumento = this.tiposDocumento;
        dialog1.componentInstance.tiposParentesco = this.tiposParentesco;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 2:  // 680	B3	¿Tuvo ingresos no gravados con renta como aportes obligatorios a pensión y a salud, entre otros?	SI	Ayuda Pregunta 3, se actualizará una vez esté revisada por el área funcional.
        let dialog2 = this.dialog.open(BeneficiosIngresosNoGravados, config);
        dialog2.componentInstance.uvt = this.uvt;
        dialog2.componentInstance.listaConceptosIngreNoGravados = this.listaConceptosIngreNoGravados;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 3:  // 757	B4	¿Tuvo rentas exentas del impuesto, que no tiene las limitantes de ley? NO	Ayuda Pregunta 4, se actualizará una vez esté revisada por el área funcional.
        let dialog3 = this.dialog.open(BeneficiosRentasExentasSinLimiteModalComponent, config);
        dialog3.componentInstance.listaConcpRentaExenSinLimite = this.listaConcpRentaExenSinLimite;
        dialog3.componentInstance.listaTipoRentaExenSinLimite = this.listaTipoRentaExenSinLimite;
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4:  // 705	B5	¿Tuvo rentas exentas de impuesto, como aportes voluntarios a pensión, cuentas AFC o cesantías?	SI	Ayuda Pregunta 5, se actualizará una vez esté revisada por el área funcional.
        let dialog4 = this.dialog.open(BeneficiosRentasExentasDeImpuestoModalComponent, config);
        dialog4.componentInstance.listaTipoRenta = this.listaTipoRenta;
        dialog4.componentInstance.conceptosRentasExentas = this.conceptosRentasExentas;
        dialog4.componentInstance.uvt = this.uvt;
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog4.afterClosed().subscribe(data => {
          this.saveModel.emit(true);
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5:  // 708	B6	¿Tuvo deducciones especiales como pagos a medicina prepagada, aportes a cesantías o 4x1.000 (GMF)?	SI	Ayuda Pregunta 6, se actualizará una vez esté revisada por el área funcional.
        let dialog5 = this.dialog.open(BeneficiosTributariosDeduccionesEspecialesModalComponent, config);
        dialog5.componentInstance.parametroTipoRenta = this.parametroPoliticaAFC;
        dialog5.componentInstance.listaTipoRenta = this.listaTipoRenta;
        dialog5.componentInstance.listaConcDeduEspe = this.listaConcDeduEspe;
        dialog5.componentInstance.uvt = this.uvt;
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 6:  // 725	B7	¿Tuvo descuentos tributarios?	NO	Ayuda Pregunta 7, se actualizará una vez esté revisada por el área funcional.
        let dialog6 = this.dialog.open(BeneficiosTributariosDescuentosModalComponent, configSinSugerida);
        dialog6.componentInstance.listConcDescTrib = this.listConcDescTrib;
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });

        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      default:
        break;
    }


  }

  protected validateModalCompleted(indexQuestion: number): boolean {
    let isModalComplete: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if ((this.model.doc.cuerpo[questions[indexQuestion].field] != undefined && this.model.doc.cuerpo[questions[indexQuestion].field] == "0") ||
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      isModalComplete = true;
    }
    if (indexQuestion == 1) {//'¿Tuvo dependientes económicos? //Caso especial por que no tiene total aquí
      if (this.model.doc.cuerpo['cc_id_669'] && this.model.doc.cuerpo['cc_id_669'].length > 0) {
        isModalComplete = true;
      }
    }
    if (isModalComplete) {
      console.log('modal is completed');
      questions[indexQuestion].isCompleted = true;
      if (questions.length > indexQuestion + 1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    } else {
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }

  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      hasValues = true;
    }
    if (indexQuestion == 1) {//'¿Tuvo dependientes económicos? //Caso especial por que no tiene total aquí
      if (this.model.doc.cuerpo['cc_id_669'] && this.model.doc.cuerpo['cc_id_669'].length > 0) {
        hasValues = true;
      }
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal: number) {
    switch (indexQuestionModal) {
      case 0:  // 651	B1	¿Hizo compras con factura electrónica?	SI	Ayuda Pregunta 1, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_652 = [];  //Origen de la información
        this.model.doc.cuerpo.cc_id_653 = [];  //Monto de facturas válidas deducción 1%
        this.model.doc.cuerpo.cc_id_654 = [];  //Valor  deducción
        this.model.doc.cuerpo.cc_id_655 = [];  //Valor Monto maximo
        this.model.doc.cuerpo.cs_id_656 = '0';  //Valor Total

        break;
      case 1:  // 668	B2	¿Tuvo dependientes económicos?	NO	Ayuda Pregunta 2, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_669 = [];  //Tipo de documento
        this.model.doc.cuerpo.cc_id_670 = [];  //Numero de documento
        this.model.doc.cuerpo.cc_id_671 = [];  //parentesco

        break;
      case 2:  // 680	B3	¿Tuvo ingresos no gravados con renta como aportes obligatorios a pensión y a salud, entre otros?	SI	Ayuda Pregunta 3, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_681 = [];  //Pagador
        this.model.doc.cuerpo.cc_id_682 = [];  //Origen de la información
        this.model.doc.cuerpo.cc_id_683 = [];  //Concepto
        this.model.doc.cuerpo.cc_id_684 = [];  //Tipo de renta
        this.model.doc.cuerpo.cc_id_685 = [];  //Valor
        this.model.doc.cuerpo.cc_id_691 = [];  //Límites RAIS
        this.model.doc.cuerpo.cs_id_691 = "0";  //Límites RAIS
        this.model.doc.cuerpo.cs_id_686 = '0';  //Total
        this.model.doc.cuerpo.cc_id_687 = [];  //sección origen
        this.model.doc.cuerpo.cs_id_676 = '0';  //Limitante
        this.model.doc.cuerpo.cs_id_677 = '0';  //Limitante
        this.model.doc.cuerpo.cs_id_678 = '0';  //Limitante
        this.model.doc.cuerpo.cs_id_679 = '0';  //Limitante

        break;
      case 3:  // 757	B4	¿Tuvo rentas exentas del impuesto, que no tiene las limitantes de ley?	NO	Ayuda Pregunta 4, se actualizará una vez esté revisada por el área funcional.

        //this.model.doc.cuerpo.cc_id_759 = [];  //Origen de la información
        this.model.doc.cuerpo.cc_id_760 = [];  //Concepto
        this.model.doc.cuerpo.cc_id_761 = [];  //Tipo de Renta
        this.model.doc.cuerpo.cc_id_762 = [];  //Valor Item
        this.model.doc.cuerpo.cs_id_763 = "0"; //Valor total


        break;
      case 4:  // 705	B5	¿Tuvo rentas exentas de impuesto, como aportes voluntarios a pensión, cuentas AFC o cesantías?	SI	Ayuda Pregunta 5, se actualizará una vez esté revisada por el área funcional. 	

        this.model.doc.cuerpo.cc_id_695 = [];  //Pagador
        this.model.doc.cuerpo.cc_id_695 = [];  //Pagador
        this.model.doc.cuerpo.cc_id_696 = [];  //Origen de la información
        this.model.doc.cuerpo.cc_id_697 = [];  //Concepto
        this.model.doc.cuerpo.cc_id_698 = [];  //Tipo de renta
        this.model.doc.cuerpo.cc_id_699 = [];  //Valor Item
        this.model.doc.cuerpo.cs_id_700 = '0';  //Total
        this.model.doc.cuerpo.cc_id_701 = [];  //seccionOrigen
        this.model.doc.cuerpo.cs_id_702 = "0"; //Valor limitado global AFC
        this.model.doc.cuerpo.cs_id_703 = "0"; //	Valor limitado global AFC Renta trabajo con costo
        this.model.doc.cuerpo.cs_id_704 = "0"; //	Valor limitado global AFC Renta Capital
        this.model.doc.cuerpo.cs_id_706 = "0"; //	Valor limitado global AFC Renta NO Laboral
        this.model.doc.cuerpo.cs_id_732 = "0"; // Valor limitado a cesantías Renta trabajo sin costo
        


        break;
      case 5:  // 708	B6	¿Tuvo deducciones especiales como pagos a medicina prepagada, aportes a cesantías o 4x1.000 (GMF)?	SI	Ayuda Pregunta 6, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_709 = [];  //Pagador
        this.model.doc.cuerpo.cc_id_710 = [];  //Origen de la información
        this.model.doc.cuerpo.cc_id_711 = [];  //Concepto
        this.model.doc.cuerpo.cc_id_712 = [];  //Tipo de Renta
        this.model.doc.cuerpo.cc_id_713 = [];  //Valor Item      
        this.model.doc.cuerpo.cc_id_719 = [];  //Limitante Intereses de vivienda
        this.model.doc.cuerpo.cc_id_720 = [];  //Limitante medicina prepagada
        this.model.doc.cuerpo.cc_id_721 = [];  //Limitante Dependientes
        this.model.doc.cuerpo.cc_id_722 = [];  //Limitante 4 * 1.000
        this.model.doc.cuerpo.cc_id_723 = [];  //Limitante Intereses ICETEX
        this.model.doc.cuerpo.cc_id_716 = [];  //numMeses
        this.model.doc.cuerpo.cc_id_715 = []; //limDepen
        this.model.doc.cuerpo.cs_id_714 = []; //Total


        break;
      case 6:  // 725	B7	¿Tuvo descuentos tributarios?	NO	Ayuda Pregunta 7, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_726 = []; //concepto	
        this.model.doc.cuerpo.cc_id_727 = []; //valor
        this.model.doc.cuerpo.cc_id_736 = []; //ingresoExt
        this.model.doc.cuerpo.cc_id_737 = []; //impuestoExt
        this.model.doc.cuerpo.cc_id_735 = []; //seccionOrigen
        this.model.doc.cuerpo.cs_id_728 = "0"; //total

        break;
      default:
        break;

    }
    this.dependenciaTarjetas(indexQuestionModal);
    this.saveModel.emit(true);

    console.log(this.model);
  }

  public validateComponentCompleted(): boolean {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].isCompleted == false) {
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.questionHasSugerida(index)) {
        const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
          data: {
            mensaje1: 'Usted tiene información sugerida para esta pregunta',
            mensaje2: 'Puede revisarla u omitirla para continuar con la siguiente pregunta.',
            botonTrue: 'Revisar',
            botonFalse: 'Omitir'
          }
        });
        dialogRef
          .afterClosed().subscribe(res => {

            if (res) {
              this.model.doc.cuerpo[data.field] = "1";//restaura el radio button a Sí
              this.validateModalCompleted(index);
              this.saveModel.emit(true);
              this.openModal(index);
              questions[index].resp = "1";
              return;//sale sin mostrar el segundo modal que pregunta si quiere eliminar los datos
            } else {
              this.validateModalCompleted(index);
            }
            this.askIfDeleteModalData(index, data);

          });

      } else {
        this.validateModalCompleted(index);
        this.askIfDeleteModalData(index, data);
      }

    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrándolo completo
      this.openModal(index);
      this.saveModel.emit(true);
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
  }

  private askIfDeleteModalData(index: number, data: any) {
    if (this.validateHasModalValues(index)) {

      const dialogRef2 = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Está seguro de eliminar esta información?',
          mensaje2: 'Al hacerlo no podrá recuperarla.',
          botonTrue: 'Sí',
          botonFalse: 'No'
        }
      });
      dialogRef2
        .afterClosed().subscribe(result => {
          if (result) { //si desea eliminar el contenido del modal
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          } else { //no desea eliminar el contenido del modal
            questions[index].resp = "1";
            this.model.doc.cuerpo[data.field] = "1";
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          }
        });
    } else {
      questions[index].isCompleted = true;
      this.cleanModalValues(index);
      this.validateModalCompleted(index);
      this.saveModel.emit(true);
    }
  }
  dependenciaTarjetas(indexQuestionModal:number)
  {
    switch (indexQuestionModal) {
      case 0:
        break;
      case 1:  // 668	B2	¿Tuvo dependientes económicos?	NO	Ayuda Pregunta 2, se actualizará una vez esté revisada por el área funcional.
        break;
      case 2:  // 680	B3	¿Tuvo ingresos no gravados con renta como aportes obligatorios a pensión y a salud, entre otros?	SI	Ayuda Pregunta 3, se actualizará una vez esté revisada por el área funcional.
        break;
      case 3:  // 757	B4	¿Tuvo rentas exentas del impuesto, que no tiene las limitantes de ley? NO	Ayuda Pregunta 4, se actualizará una vez esté revisada por el área funcional.
        
        const componentIngAsalariadoServPub3 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
        componentIngAsalariadoServPub3.instance.initializeTablaDesdeModelo();
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cc_id_279.length.toString(), '0') || this.model.doc.cuerpo.cc_id_279 == undefined)
        {
          componentIngAsalariadoServPub3.instance.inicializeForm();
        }
        componentIngAsalariadoServPub3.instance.operacionesLimitantesComunes();
        componentIngAsalariadoServPub3.instance.operacionCs280();
    
        const componentIngTrabIndependiente3= this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
        componentIngTrabIndependiente3.instance.initializeTablaDesdeModelo();
        componentIngTrabIndependiente3.instance.operacionCs305();
        
    
        const componentBenIngNoRenta3= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
    
        componentBenIngNoRenta3.instance.uvt = this.uvt;//corrige uvt quemada $42412
        componentBenIngNoRenta3.instance.reset();
        componentBenIngNoRenta3.instance.initializeTablaDesdeModelo();
        componentBenIngNoRenta3.instance.operacionCS691();
        componentBenIngNoRenta3.instance.operacionCS676();
        componentBenIngNoRenta3.instance.guardar();
        break;
      case 4:  // 705	B5	¿Tuvo rentas exentas de impuesto, como aportes voluntarios a pensión, cuentas AFC o cesantías?	SI	Ayuda Pregunta 5, se actualizará una vez esté revisada por el área funcional.
        break;
      case 5:  // 708	B6	¿Tuvo deducciones especiales como pagos a medicina prepagada, aportes a cesantías o 4x1.000 (GMF)?	SI	Ayuda Pregunta 6, se actualizará una vez esté revisada por el área funcional.
      const componentAsalariado5 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentAsalariado5.instance.initializeTablaDesdeModelo();
      const table = componentAsalariado5.instance.dataSourceBody;
      componentAsalariado5.instance.UVT = this.uvt;
      if(table)
        for(let i=0; i<table.length; i++){
          componentAsalariado5.instance.modelForm = table[i];
          componentAsalariado5.instance.operacionCc297();
          this.model.doc.cuerpo.cc_id_297[i].v = componentAsalariado5.instance.modelForm.limitanteVeinticincoexento;
          componentAsalariado5.instance.inicializeForm();
        } 
        break; 
      case 6:  // 725	B7	¿Tuvo descuentos tributarios?	NO	Ayuda Pregunta 7, se actualizará una vez esté revisada por el área funcional.
      
      break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/mis-beneficios-tributarios/mis-beneficios-tributarios.component.ts